import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/(marketing)/tools/slug-generator/page-client.tsx");
